// extracted by mini-css-extract-plugin
export var emptyState = "_5z-d";
export var statCard = "_5z-c";
export var table = "_5z-0";
export var tableCell = "_5z-4";
export var tableCellClickable = "_5z-5 _5z-4";
export var tableCellDefault = "_5z-6 _5z-4";
export var tableCellEmpty = "_5z-8";
export var tableCellWithValue = "_5z-7";
export var tableContainer = "_5z-e";
export var tableHeaderWeight = "_5z-1";
export var tableHeaderZone = "_5z-2";
export var tableRowHeader = "_5z-3";
export var viewModeButton = "_5z-9";
export var viewModeButtonActive = "_5z-a _5z-9";
export var viewModeButtonInactive = "_5z-b _5z-9";